import React from 'react'
import './Header.css'
const Header = () => {
  return (
    <div className='header'>
        <div className='header-contents'>
            <h2>Order your Favourite Food Here</h2>
            <p></p>
            <button>View menu</button>
        </div>
    </div>
  )
}

export default Header
